import React, { Component } from 'react';
import {
  FlatList,
  InteractionManager,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import { connect } from 'react-redux';
import _ from 'lodash';

import { FontAwesomeIcon, Modal } from '../modules';
import Utils from '../utils/Utils';
import UserUtils from '../utils/UserUtils';
import APIClient from '../utils/APIClient';
import FilterList, { filterItemList } from './FilterList';
import Empty from '../common/Empty';
import SearchInput from '../common/SearchInput';
import Icon from '../common/Icon';
import FilterUtils from '../utils/FilterUtils';
import OrderHeader from '../item/OrderHeader';
import OrderItem from '../item/OrderItem';
import UserManager from '../utils/UserManager';

class OrderListScreen extends Component {

  static navigationOptions = ({navigation}) => {
    const {routes, params} = navigation.state;
    const {query, isAdmin, updateQuery, search} = params ? params : {};
    return {
      tabBarIcon: ({focused, tintColor}) => {
        return (
          <Icon
            type='FontAwesome'
            name='home'
            size={30}
            color={tintColor}/>
        );
      },
      tabBarVisible: !routes || routes.length <= 1,

      headerBackTitle: null,
      headerTitle: (
        <SearchInput
          placeholder='ID / Emai / số điện thoại khách hàng'
          query={query}
          onUpdateQuery={updateQuery}
          onSubmit={search}/>
      ),
      headerLeft: null,
      headerRight: null,
    };
  };

  constructor (props) {
    super(props);

    const {user} = this.props;
    const isAdmin = UserUtils.isAdmin(user);
    const isSeller = UserUtils.isSeller(user);

    this._filter = filterItemList[0];
    this._query = '';
    this._page = -1;
    this._loading = false;
    const items = [];
    this.state = {
      isAdmin: isAdmin,
      isSeller: isSeller,
      filter: this._filter,
      query: this._query,
      refreshing: false,
      showingFilterList: false,
      items: items,
      noitem: false,
    };
  }

  componentDidMount () {
    if (Platform.OS === 'web') {
      if (this.props.location.state !== null && this.props.location.state !==
        undefined) {
        this._filter = this.props.location.state.filter;
        this._query = this.props.location.state.query;
        this.setState({
          filter: this.props.location.state.filter,
          query: this.props.location.state.query,
        });
      }
    } else {
      const {navigation, user} = this.props;
      // console.log('user: ' + JSON.stringify(user));
      const isAdmin = UserUtils.isAdmin(user);
      const {query} = this.state;
      navigation.setParams({
        isAdmin: isAdmin,
        query: query,
        updateQuery: this._updateQuery,
        search: this._search,
      });
    }

    InteractionManager.runAfterInteractions(() => {
      this._refreshData(false);
    });
  }

  componentWillUnmount () {
  }

  componentWillReceiveProps = (nextProps) => {
    if (Platform.OS === 'web') {
      if (nextProps.location.state !== null && nextProps.location.state !==
        undefined) {
        const {query, filter} = nextProps.location.state;
        this._filter = filter;
        this._query = query;
        this.setState({
          filter: filter,
          query: query,
        });
      }
      this._refreshData(false);
    }
  };

  _updateFilter = (filter) => {
    this._closeFilterList();

    if (this.state.filter == filter) {
      return;
    }

    this._filter = filter;
    this.setState({
      filter: filter,
    });

    if (Platform.OS === 'web') {
      this.props.history.push({
        pathname: '/',
        state: {
          query: this._query,
          filter: this._filter,
        },
      });
    } else
      this._refreshData(false);
  };

  _updateQuery = (query) => {
    if (this._query === query) {
      return;
    }

    this._query = query;
    this.setState({
      query: query,
    });
    if (Platform.OS !== 'web') {
      this.props.navigation.setParams({
        query: query,
      });
    }
  };

  _search = () => {
    this._loading = false;
    this._page = 1;
    this.setState({
      refreshing: false,
      items: [],
    });
    if (Platform.OS === 'web') {
      this.props.history.push({
        pathname: '/',
        state: {
          query: this._query,
          filter: this._filter,
        },
      });
    } else
      this._loadData();
  };

  _refreshData = (refreshing) => {
    if (this._loading) {
      return;
    }

    this._resetData(refreshing);
    this._loadData();

    const {isAdmin, isSeller} = this.state;
    if (isAdmin || isSeller) {
      this._loadRevenue();
    }
  };

  _resetData (refreshing) {
    this._loading = false;
    this._page = 1;
    const items = [];
    this.setState({
      revenue: null,
      refreshing: refreshing,
      items: items,
      noitem: false,
    });
  }

  _loadRevenue = async () => {
    const params = FilterUtils.parseTime(this._filter.key);
    // console.log('params: ' + JSON.stringify(params));
    const {response, error} = await APIClient.GET('/user/revenue', params);
    this._handleRevenueNetworkResponse(response, error);
  };

  _handleRevenueNetworkResponse (response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    if (response) {
      this.setState({
        revenue: response.response,
      });
    }
  }

  _loadData = async () => {
    if (this._loading || this._page <= 0) {
      return;
    }

    this._loading = true;

    const time = FilterUtils.parseTime(this._filter.key);
    const params = {
      ...time,
      page: this._page,
      limit: 30,
    };
    if (!_.isEmpty(this._query)) {
      params.query = this._query;
    }
    if (this._filter.key.startsWith('@')) {
      params.query = params.query === undefined || params.query === null
        ? this._filter.key.trim() :
        (params.query + ' ' + this._filter.key).trim();
    }

    const {response, error} = await APIClient.GET('/orders', params);
    this._handleNetworkResponse(response, error);
  };

  _handleNetworkResponse (response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    let {items, noitem} = this.state;
    if (response && response.response) {
      const newItems = response.response;
      if (newItems.length > 0) {
        items = items.concat(newItems);
        this._page++;
        this.setState({
          items: items,
        });
      } else {
        this._page = -1;
      }
      noitem = items.length === 0;
    } else {
      noitem = _.isEmpty(items);
    }

    this._loading = false;
    this.setState({
      refreshing: false,
      noitem: noitem,
    });
  }

  _openFilterList = () => {
    this.setState({
      showingFilterList: true,
    });
  };

  _closeFilterList = () => {
    this.setState({
      showingFilterList: false,
    });
  };

  _keyExtractor = item => `${item.id}`;

  _onRefresh = () => this._refreshData(true);

  _onEndReached = () => this._loadData();

  _renderItem = ({item, index}) => {
    return (
      <OrderItem
        simple={!UserManager.getInstance().isAdmin()}
        data={item}
        onClick={this._handleClickItem}/>
    );
  };

  _handleClickItem = (item) => {
    if (Platform.OS === 'web') {
      const path = '/order/' + item.id;
      this.props.history.push(path);
    } else {
      const {navigation} = this.props;
      navigation.navigate('Order', {
        id: item.id,
      });
    }
  };

  render () {
    const {isAdmin, isSeller, filter, refreshing, revenue, items, noitem, showingFilterList, query} = this.state;
    return (
      <View
        style={styles.container}>

        {Platform.OS === 'web' && <SearchInput
          placeholder='ID / Emai / số điện thoại khách hàng'
          query={query}
          onUpdateQuery={this._updateQuery}
          onSubmit={this._search}/>}

        <TouchableOpacity
          activeOpacity={0.75}
          onPress={this._openFilterList}
          style={styles.filter}>
          <Text
            style={styles.filterTitleText}>
            Bộ lọc
          </Text>
          <Text
            style={styles.filterValueText}>
            {filter.title}
          </Text>
          {Platform.OS !== 'web' && <FontAwesomeIcon
            name='arrow-right'
            size={16}
            color='#ffffff'
            style={styles.filterArrowIcon}/>}
        </TouchableOpacity>

        {(isAdmin || isSeller) && <View
          style={styles.revenue}>
          <Text
            style={styles.revenueText}>
            {Utils.priceToString(revenue)}
          </Text>
        </View>}

        <OrderHeader
          simple={!UserManager.getInstance().isAdmin()}/>

        <FlatList
          refreshing={refreshing}
          extraData={this.state}
          data={items}
          keyExtractor={this._keyExtractor}
          onRefresh={this._onRefresh}
          onEndReached={this._onEndReached}
          onEndReachedThreshold={0.5}
          renderItem={this._renderItem}
          style={styles.list}/>

        {noitem && <Empty
          text='Không có đơn hàng, bấm để thử lại'
          onClick={() => this._refreshData(false)}
          style={styles.empty}/>}

        {Platform.OS !== 'web' && <Modal
          animationType='fade'
          transparent={true}
          visible={showingFilterList}
          onRequestClose={this._closeFilterList}>
          <FilterList
            filter={filter}
            onClose={this._closeFilterList}
            onSelectFilter={this._updateFilter}/>
        </Modal>}

        {Platform.OS === 'web' && <Modal
          isOpen={showingFilterList}
          onRequestClose={this._closeFilterList}
          style={webModalStyles}>
          <FilterList
            filter={filter}
            onClose={this._closeFilterList}
            onSelectFilter={this._updateFilter}/>
        </Modal>}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },

  filter: {
    height: 44,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#6b7adc',
  },
  filterTitleText: {
    flex: 1,
    marginLeft: 10,
    color: '#ffffff',
    fontSize: 17,
    fontWeight: '100',
    backgroundColor: 'transparent',
  },
  filterValueText: {
    marginRight: 10,
    color: '#ffffff',
    fontSize: 17,
    fontWeight: '300',
    backgroundColor: 'transparent',
  },
  filterArrowIcon: {
    marginRight: 10,
  },

  revenue: {
    height: 64,
    justifyContent: 'center',
    alignItems: 'center',
  },
  revenueText: {
    color: '#ff4f4f',
    fontSize: 32,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
  },

  list: {
    flex: 1,
  },

  empty: {
    ...Platform.select({
      web: {
        top: 100,
      },
      ios: {
        top: 44,
      },
      android: {
        top: 44,
      },
    }),
  },
});

const webModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderListScreen);



// WEBPACK FOOTER //
// ./src/order/OrderListScreen.js